<template>
    <main class="honor" id="topDom">
        <section class="honor-section">
          <ul class="breadcrumb">
            <li class="breadcrumb__li --current">
              <router-link to="/" class="breadcrumb__link">{{ $t("i18n.home") }}</router-link>
            </li>
            <li class="breadcrumb__li">
              <span class="breadcrumb__text"> {{ $t("i18n.honor.name") }}</span>
            </li>
          </ul>
          <div class="banner">
            <div class="banner__bg">
              <img :src="imgUrl" />
            </div>
            <div class="banner__content container-fluid">
              <div class="row align-items-center">
                <div class="col-12 col-md-6 order-2 order-md-1">
                  <h1 class="banner__title">{{ $t("i18n.honor.name") }}</h1>
                  <p class="banner__text">{{ $t("i18n.honor.subText") }}</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="container honor-section-contant">
            <div class="contant-title">{{ $t("i18n.honorText1") }}</div>
            <div class="certificate-list">
                <div class="certificate-items">
                    <div class="certificate-item">
                        <div class="d-flex align-items-center">
                            <div class="certificate-item-round" :class="{ 'active': honorShow }"></div>
                            <div style="font-size: 1.6rem;">{{ $t("i18n.honorText2") }}</div>
                        </div>
                        <div @click="() => { honorShow = !honorShow; patentShow = false }" class="certificate-item-look"
                            :class="{ 'certificate-item-look2': !honorShow }">{{ $t("i18n.honorText3") }}</div>
                    </div>
                  <div class="outSwiperBox">
                    <div v-show="honorShow" id="honor-swiper">
                      <div class="swiper-container honor-swiper honor-swiper1">
                        <div class="swiper-wrapper">
                          
                          <div class="swiper-slide">
                            <div class="swiper-slide-show">
                              <viewer class="swiper-viewer">
                                <img class="swiper-lazy img-responsive img-fluid"
                                     src="../assets/imgs/honor-swiper-1.png" alt="轮播图">
                              </viewer>
                            </div>
                          </div>
                          <div class="swiper-slide">
                            <div class="swiper-slide-show">
                              <viewer class="swiper-viewer">
                                <img class="swiper-lazy img-responsive img-fluid"
                                     src="../assets/imgs/honor-swiper-2.png" alt="轮播图">
                              </viewer>
                            </div>
                          </div>
                          <div class="swiper-slide">
                            <div class="swiper-slide-show">
                              <viewer class="swiper-viewer">
                                <img class="swiper-lazy img-responsive img-fluid"
                                     src="../assets/imgs/honor-swiper-3.png" alt="轮播图">
                              </viewer>
                            </div>
                          </div>
                          <div class="swiper-slide">
                            <div class="swiper-slide-show">
                              <viewer class="swiper-viewer">
                                <img class="swiper-lazy img-responsive img-fluid"
                                     src="../assets/imgs/honor-swiper-4.png" alt="轮播图">
                              </viewer>
                            </div>
                          </div>

                        </div>
                        <!-- 导航按钮 -->
                        <div class="swiper-button-prev honor-swiper-button-prev"></div>
                        <div class="swiper-button-next honor-swiper-button-next"></div>
                      </div>
                    </div>

                  </div>
                </div>
                <div class="certificate-items">
                    <div class="certificate-item">
                        <div class="d-flex align-items-center">
                            <div class="certificate-item-round" :class="{ 'active': patentShow }"></div>
                            <div style="font-size: 1.6rem;">{{ $t("i18n.honorText4") }}</div>
                        </div>
                        <div @click="() => {
                            patentShow = !patentShow
                            honorShow = false
                        }" class="certificate-item-look" :class="{ 'certificate-item-look2': !patentShow }">{{ $t("i18n.honorText3") }}</div>
                    </div>
                  <div class="outSwiperBox">
                    <div v-show="patentShow" id="honor-swiper">
                      <div class="swiper-container honor-swiper honor-swiper2">
                        <div class="swiper-wrapper">
                          <div class="swiper-slide">
                            <div class="swiper-slide-show">
                              <viewer>
                                <img class="swiper-lazy img-responsive img-fluid"
                                     src="../assets/imgs/patent-swiper-1.png" alt="轮播图">
                              </viewer>
                            </div>
                          </div>
                          <div class="swiper-slide">
                            <div class="swiper-slide-show">
                              <viewer>
                              <img class="swiper-lazy img-responsive img-fluid"
                                   src="../assets/imgs/patent-swiper-2.png" alt="轮播图">
                              </viewer>
                            </div>
                          </div>
                          <div class="swiper-slide">
                            <div class="swiper-slide-show">
                              <viewer class="swiper-viewer">
                              <img class="swiper-lazy img-responsive img-fluid"
                                   src="../assets/imgs/patent-swiper-3.png" alt="轮播图">
                              </viewer>
                            </div>
                          </div>
                          <div class="swiper-slide">
                            <div class="swiper-slide-show">
                              <viewer class="swiper-viewer">
                              <img class="swiper-lazy img-responsive img-fluid"
                                   src="../assets/imgs/patent-swiper-4.png" alt="轮播图">
                              </viewer>
                            </div>
                          </div>
                          <div class="swiper-slide">
                            <div class="swiper-slide-show">
                              <viewer class="swiper-viewer">
                              <img class="swiper-lazy img-responsive img-fluid"
                                   src="../assets/imgs/patent-swiper-5.png" alt="轮播图">
                              </viewer>
                            </div>
                          </div>
                          <div class="swiper-slide">
                            <div class="swiper-slide-show">
                              <viewer class="swiper-viewer">
                              <img class="swiper-lazy img-responsive img-fluid"
                                   src="../assets/imgs/patent-swiper-6.png" alt="轮播图">
                              </viewer>
                            </div>
                          </div>
                          <div class="swiper-slide">
                            <div class="swiper-slide-show">
                              <viewer class="swiper-viewer">
                              <img class="swiper-lazy img-responsive img-fluid"
                                   src="../assets/imgs/patent-swiper-7.png" alt="轮播图">
                              </viewer>
                            </div>
                          </div>

                        </div>
                        <!-- 导航按钮 -->
                        <div class="swiper-button-prev honor-swiper-button-prev"></div>
                        <div class="swiper-button-next honor-swiper-button-next"></div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
        </section>
        <section class="container honor-footer">
            <div class="white-box-links" @click="goPage('Home')">
                <p class="footer-title">{{ $t("i18n.company") }}</p>
                <p class="footer-subtitle">{{ $t("i18n.backHomePage") }}</p>
            </div>
        </section>
    </main>
</template>

<script>
import Swiper from "swiper";
import 'viewerjs/dist/viewer.css'
import { component as Viewer } from "v-viewer"
export default {
  components: { Viewer },
    data() {
        return {

          imgUrl: this.isMobile() ? require("../assets/imgs/honorBg-p.png") : require("../assets/imgs/honor.png"),
            class1: {
                transform: ""
            },
            swiper: null,
            activeIndex: 0,
            // 可以在这里设置轮播的选项
            settings: {
                arrows: true,
                dots: true,
                autoplay: true,
                autoplaySpeed: 2000,
                slidesToShow: 1,
                slidesToScroll: 1,
            },
            honorShow: false,
            patentShow: false,
        };
    },
    mounted() {
        this.goTop();
        let swiper = new Swiper(".honor-swiper1", {
            loop: true, // 循环模式选项
            slidesPerView: 4,
            loopedSlides: 8,
            // 如果需要前进后退按钮
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            },
            //自动播放
            autoplay: {
              delay: 1500,
              stopOnLastSlide: false,
              disableOnInteraction: false
            },
            // 延迟加载
            lazy: {
                loadPrevNext: true
            },
            observer: true, //修改swiper自己或子元素时，自动初始化swiper
            observeParents: true //修改swiper的父元素时，自动初始化swiper
        });

        let swiper2 = new Swiper(".honor-swiper2", {
            loop: true, // 循环模式选项
            slidesPerView: 4,
            loopedSlides: 9,
            // 如果需要前进后退按钮
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            },
            //自动播放
            autoplay: {
              delay: 1500,
              stopOnLastSlide: false,
              disableOnInteraction: false
            },
            // 延迟加载
            lazy: {
                loadPrevNext: true
            },
            observer: true, //修改swiper自己或子元素时，自动初始化swiper
            observeParents: true //修改swiper的父元素时，自动初始化swiper
        });
    },
  created() {
    this.goTop();
  },
  methods: {
    isMobile() {
      return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    },
    goPage(path) {
      this.$router.push(path)
    },
    goTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' }); // 平滑滚动到顶部
      // setTimeout(()=>{
      //   document.querySelector('#topDom').scrollIntoView({
      //     behavior: 'smooth'
      //   })
      // },100)
    }
  }
}
</script>

<style scoped>
.img-responsive {
  width: 90% !important;
}
.honor-section {
    position: relative;
}

.breadcrumb {
  display: flex;
  height: 8rem;
  align-items: center;
  position: absolute;
  z-index: 80;
  left: 5rem;
  margin: 0;
  padding: 0;
}
.breadcrumb__li {
  position: relative;
  padding-right: 2.5rem;
  margin-right: 2rem;
}
.breadcrumb__link {
  font-size: 1.6rem;
  line-height: 1.9rem;
  color: #EEEEEE;
  letter-spacing: 0;
  display: block;
  max-width: 20rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.breadcrumb__li.--current:after {
  content: "";
  width: 0.6rem;
  height: 1rem;
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -0.3rem;
  background: url(../assets/imgs/arrow-breadcrumb.svg) no-repeat 50%;
}
.breadcrumb__li:last-child {
  padding-right: 0;
  margin-right: 0;
}
.breadcrumb__text {
  font-size: 1.6rem;
  line-height: 1.9rem;
  color: #EEEEEE;
  letter-spacing: 0;
  display: block;
  max-width: 20rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.banner {
  height: 61rem;
  align-items: center;
  display: flex;
}
.banner__bg {
  position: absolute;
  width: 100%;
  height: 61rem;
}
.banner__bg {
  z-index: 1;
}
.banner__bg img {
  max-width: 100%;

  display: block;
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  -o-object-position: 50% 50%;
  object-position: 50% 50%;
}

.banner__content {
  position: relative;
  z-index: 2;
}
.banner__title {
  font-weight: 500;
  font-size: 4rem;
  color: #fff;
  letter-spacing: -.084rem;
  line-height: 6rem;
}
.banner__text {
  margin-top: 3rem;
  font-size: 2.1rem;
  font-weight: 500;
  color: #fff;
  letter-spacing: -.022rem;
  line-height: 3.3rem;
  padding-right: 2rem;
}
.honor-subtext {
    position: absolute;
    height: 15rem;
    left: 13%;
    top: 30%;
    color: #FFFFFF;
    font-size: 2.8rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.honor-subtext-title {
    font-size: 5rem;
}

.honor-section-contant {
    padding: 0;
    padding-top: 13rem;
}

.contant-title {
    font-size: 3.2rem;
    color: #231815;
    margin-bottom: 2rem;
}

.certificate-item {
    width: 100%;
    height: 6rem;
    border-bottom: 0.1rem solid #CCCCCC;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 2rem;
    color: #231815;
}

.certificate-item-round {
    width: 1.1rem;
    height: 1.1rem;
    border-radius: 50%;
    border: 0.1rem solid #7E318E;
    /* background-color: #7E318E; */
    margin-right: 3.6rem;
}

.certificate-item-round.active {
    width: 1.3rem;
    height: 1.3rem;
    border-radius: 50%;
    border: none;
    background-color: #7E318E;
    margin-right: 3.6rem;
}

.certificate-item-look {
    color: #7E318E;
    width: 10rem;
    cursor: pointer;
    position: relative;
}

.certificate-item-look::after {
    content: ">";
    font-size: 2.4rem;
    position: absolute;
    right: 10%;
    top: -10%;
    color: #7E318E;
    transform: rotate(90deg);
}

.certificate-item-look2::after {
    content: ">";
    font-size: 2.4rem;
    position: absolute;
    right: 10%;
    top: -10%;
    color: #7E318E;
    transform: rotate(0deg);
}

.outSwiperBox {
  position: relative;
  padding: 0 50px;
}
.honor-swiper {
    height: 32rem;
    width: 100%;
    position: initial;
}

.swiper-slide-show {
    width: 100%;
    height: 100%;
    display: flex;
    /* justify-content: space-around; */
    justify-content: center;
    align-items: center;
}

.swiper-viewer {
  display: flex;
  justify-content: center;
}

.honor-swiper-button-prev {
    background-image: url("../assets/imgs/honor-left.png");
    background-size: 12px 36px;
    left: 0%;
}

.honor-swiper-button-next {
    background-image: url("../assets/imgs/honor-right.png");
    background-size: 12px 36px;
    right: 0%;
}

.img-fluid:hover {
  transform: scale(1.1);
  transition: all 0.3s ease-in-out;
}



.honor-footer {
    padding: 10rem 0;
}

.breadcrumb {
    display: flex;
    height: 8rem;
    align-items: center;
    position: absolute;
    z-index: 80;
    top: 0;
    left: 7.6%;
    margin: 0;
    padding: 0;
}

.breadcrumb__li {
    position: relative;
    padding-right: 2.5rem;
    margin-right: 2rem;
}

.breadcrumb__link {
    font-size: 1.6rem;
    line-height: 1.9rem;
    color: #e3e3e3;
    letter-spacing: 0;
    display: block;
    max-width: 20rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.breadcrumb-right:after {
    content: ">";
    width: 0.6rem;
    height: 1rem;
    position: absolute;
    right: 0%;
    top: 0%;
    color: #EEEEEE;
}

.breadcrumb__li:last-child {
    padding-right: 0;
    margin-right: 0;
}

.breadcrumb__li {
    position: relative;
    padding-right: 2.5rem;
    margin-right: 2rem;
}

.breadcrumb__text {
    font-size: 1.8rem;
    line-height: 1.9rem;
    color: #EEEEEE;
    letter-spacing: 0;
    display: block;
    max-width: 20rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.white-box-links {
    width: 60%;
    padding-left: 5%;
    background: #fff;
    border: 0.1rem solid #e6e6e6;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 19.2rem;
    border-radius: 0.4rem;
    box-shadow: 0 0.2rem 0.4rem 0 rgba(0, 0, 0, .05);
    transition: all .2s ease-in-out;
    cursor: pointer;
}



.footer-title {
    /* font-size: 2rem; */
    font-size: 1.3rem;
    font-weight: 500;
    color: #231815;
    margin-bottom: 2rem;
    margin-top: 1rem;
}

.footer-subtitle {
    /* font-size: 5rem; */
    font-size: 3rem;
    font-weight: 700;
    color: #7E318E;
    position: relative;
}

.footer-subtitle::after {
    content: ">";
    font-size: 3.7rem;
    position: absolute;
    right: 10%;
    top: 20%;
    color: #7E318E;
}

.white-box-links:hover {
  background: #990099;
}

.white-box-links:hover .footer-title,
.white-box-links:hover .footer-subtitle {
  color: #FFF;
}


@media (max-width: 1023.9px) {
  .white-box-links {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/honor.vue